/**
 * @generated SignedSource<<b1d607e78efe43adc0e0d3e15cbf41bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionViewNftTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_viewer" | "NftProfileImportCollectionRetry_viewer">;
  readonly " $fragmentType": "NftProfileImportCollectionViewNftTile_viewer";
};
export type NftProfileImportCollectionViewNftTile_viewer$key = {
  readonly " $data"?: NftProfileImportCollectionViewNftTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewNftTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionViewNftTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionRetry_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "60f9c0886621661bf78094e0697ebc70";

export default node;
